"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const region_scss_1 = __importDefault(require("./styles/region.scss"));
var Phase;
(function (Phase) {
    Phase[Phase["DisplayNone"] = 0] = "DisplayNone";
    Phase[Phase["Out"] = 1] = "Out";
    Phase[Phase["In"] = 2] = "In";
})(Phase || (Phase = {}));
/**
 * Inspired react-transition-group/transition
 * but it apply "display: none;" for performance reason
 * @param param
 */
function Transition(props) {
    const [phase, setPhase] = React.useState(props.in ? Phase.In : Phase.DisplayNone);
    const timerRef = React.useRef(0);
    /**
     * props.out になった時点の props.exiting を保持 => 次に props.in になった時に適用する
     */
    const [exiting, setExiting] = React.useState(props.exiting);
    React.useEffect(() => {
        if (phase === Phase.DisplayNone && props.in) {
            setPhase(Phase.Out);
            return;
        }
        if (phase === Phase.Out && props.in) {
            window.clearTimeout(timerRef.current);
            // HACK: [ DisplayNone -> Out --(enough delay)--> In ] for waiting calucration
            window.setTimeout(() => {
                setPhase(Phase.In);
            }, 100);
            return;
        }
        if (phase === Phase.In && !props.in) {
            setExiting(props.exiting);
            setPhase(Phase.Out);
            timerRef.current = window.setTimeout(() => {
                setPhase(Phase.DisplayNone);
            }, props.timeout || 150);
        }
    }, [phase, props.in]);
    return (React.createElement("div", { className: classnames_1.default(props.className, phase === Phase.Out && exiting, phase === Phase.DisplayNone && region_scss_1.default.displayNone) }, props.children));
}
exports.Transition = Transition;
